import { WidgetProps } from '@rjsf/core';
import CustomCheckbox from './CustomCheckbox';

const FillSpaceProperty = (props: WidgetProps) => {
    const { schema, onChange } = props;

    const handleCheckboxChange = (e: any) => {
        if (e === 'true') {
            onChange('1');
        } else {
            onChange('0');
        }
    };
    return (
        <div className="fill-space-property">
            <label>{schema?.title}</label>
            <CustomCheckbox {...props} schema={schema} onChange={handleCheckboxChange} />
        </div>
    );
};

export default FillSpaceProperty;
